<template>
  <v-row>
    <attach-keybe-ui v-model="showAttachKeybeUiDialog"></attach-keybe-ui>
    <v-col cols="12">
      <v-row class="py-2 px-4" align="center" justify="space-between">
        <h2 style="display: inline" class="hidden-xs-only kbDarkBlueText--text">Keybe UI</h2>
        <v-spacer></v-spacer>
        <v-btn color="kbLightBlue" dark large @click="showAttachKeybeUi()">
          <v-icon left>attachment</v-icon>
            {{$t('general.attachInWebSite')}}
        </v-btn>
      </v-row>
    </v-col>

    <v-col cols="12">
      <SelectPicture @cropped="updatePicture($event)"
                     :loading="uploadingPhoto"
                     v-model="selectPictureDialog">
      </SelectPicture>
    </v-col>

    <v-col cols="12" md="6">
      <v-row justify="center">
        <div class="flex" style="max-width: 500px">
          <v-card color="kbWhite" style="max-width: 500px">
            <v-card-text :style="{background: selectedApp.color || '#657b7d'}" style="min-height: 130px"/>

            <v-card-actions style="margin-top: -80px" class="hidden-sm-and-down">
              <v-avatar class="elevation-1 mb-2 ml-2" color="white" size="100">
                <img v-if="selectedApp.photo" :src="selectedApp.photo">
                <v-icon v-if="!selectedApp.photo" size="80">face</v-icon>
              </v-avatar>

              <v-label>
                <span class="white--text ml-2">{{$t('general.name')}} {{$t('general.and')}} {{$t('general.lastName')}}</span>
              </v-label>
            </v-card-actions>

            <v-card-actions class="hidden-md-and-up" style="margin-top: -90px">
              <v-row>
                <v-col class="text-center" cols="12" >
                  <v-avatar class="elevation-1 mb-2 ml-2" color="white" size="100">
                    <img v-if="selectedApp.photo" :src="selectedApp.photo">
                    <v-icon v-if="!selectedApp.photo" size="80">face</v-icon>
                  </v-avatar>
                </v-col>

                <v-col class="text-center" cols="12" style="margin-top: -15px">
                  <v-label>
                    <span>{{$t('general.name')}} {{$t('general.and')}} {{$t('general.lastName')}}</span>
                  </v-label>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </div>
      </v-row>

      <v-row class="mt-6"  justify="center" >
        <div class="flex" style="max-width: 500px">
          <v-card class="mx-4 elevation-0"
                  style="z-index: 1"
                  :style="{background: selectedApp.color || '#657b7d'}">
            <v-row align="center" justify="center" style="min-height: 100px">
              <span class="white--text font-weight-bold" v-if="focus === 'none'">{{keybeUi.personalizedSentence || 'KEYBE'}}</span>
              <span class="white--text font-weight-bold" v-if="focus === 'login'">{{keybeUi.loginPhrase || 'KEYBE'}}</span>
              <span class="white--text font-weight-bold" v-if="focus === 'register'">{{keybeUi.registerPhrase || 'KEYBE'}}</span>
            </v-row>
          </v-card>
          <v-card class="kbWhite" style="margin-top: -30px; min-height: 170px">
            <v-card-text>
              <v-row class="mx-6"   >
                <v-col class="text-center mt-12" cols="12" style="font-size: 13px" >
                  <v-row align="center">
                    <v-divider></v-divider>
                    <span class="px-4">{{focus === 'login' ? $t('general.logInWith') : $t('general.signInWith')}}</span>
                    <v-divider></v-divider>
                  </v-row>
                </v-col>
                <SocialNetworks/>
                <v-col cols="12" style="min-height: 100px"></v-col>
                <v-col class="text-center pa-0 pb-2 ma-0" cols="12" >
                  <v-btn block dark :color="selectedApp.color">
                    <span v-if="focus === 'login'">{{keybeUi.labelLoginButton || $t('general.logInToYourAccount')}}</span>
                    <span v-else-if="focus === 'register'">{{keybeUi.labelRegisterButton || $t('general.signIn')}}</span>
                    <span v-else>{{$t('general.signIn')}}</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </div>
      </v-row>
    </v-col>

    <v-col cols="12" md="6">
      <v-col class="text-center text-md-left" cols="12" >
        <v-btn class="mr-2"
               color="kbBlue"
               outlined
               @click="selectPictureDialog = true">
            {{$t('general.selectLogo')}}
        </v-btn>

        <v-btn color="kbBlue"
               dark
               @click="colorPickerDialog = true">
            {{$t('general.selectColor')}}
        </v-btn>
      </v-col>

      <v-col cols="12" class="py-0">
        <v-label>{{$t('general.customPhrase')}}</v-label>
        <v-text-field @focus="focus = 'none'"
                      color="kbDarkBlueText"
                      background-color="kbWhite"
                      solo
                      v-model="keybeUi.personalizedSentence"></v-text-field>
      </v-col>

      <v-col cols="12" class="py-0">
        <v-label>{{$t('general.customPhraseOnLogIn')}}</v-label>
        <v-text-field color="kbDarkBlueText"
                      @focus="focus = 'login'"
                      background-color="kbWhite"
                      solo
                      v-model="keybeUi.loginPhrase"></v-text-field>
      </v-col>

      <ColorPicker v-model="colorPickerDialog" :color="selectedApp.color"></ColorPicker>

      <v-col cols="12" class="py-0">
        <v-label>{{$t('general.customPhraseOnSignIn')}}</v-label>
        <v-text-field color="kbDarkBlueText"
                      @focus="focus = 'register'"
                      background-color="kbWhite"
                      solo
                      v-model="keybeUi.registerPhrase"></v-text-field>
      </v-col>

      <v-col cols="12" class="py-0">
        <v-label>{{$t('general.enterSignInMode')}}</v-label>
        <v-select color="kbDarkBlueText"
                  v-model="keybeUi.registerMode"
                  :label="$t('general.signInWith')"
                  :items="registerModeItems"
                  item-text="text"
                  item-value="value"
                  background-color="kbWhite"
                  solo></v-select>
      </v-col>

      <v-col cols="12" class="py-0">
        <v-label>{{$t('general.customPhraseOnLogInButton')}}</v-label>
        <v-text-field color="kbDarkBlueText"
                      background-color="kbWhite"
                      solo
                      @focus="focus = 'login'"
                      v-model="keybeUi.labelLoginButton"></v-text-field>
      </v-col>

      <v-col cols="12" class="py-0">
        <v-label>{{$t('general.customPhraseOnSignInButton')}}</v-label>
        <v-text-field color="kbDarkBlueText"
                      background-color="kbWhite"
                      solo
                      @focus="focus = 'register'"
                      v-model="keybeUi.labelRegisterButton"></v-text-field>
      </v-col>
    </v-col>

    <v-col cols="12" sm="6">
      <v-switch
        color="kbBlue"
        :label="$t('general.hideSocialNetworks')"
        v-model="keybeUi.hideSocialNetworks"
        hide-details>
      </v-switch>
    </v-col>

    <v-col cols="12" sm="6">
      <v-switch
        color="kbBlue"
        :label="$t('general.showSignInFirst')"
        v-model="keybeUi.showRegisterFirst"
        hide-details>
      </v-switch>
    </v-col>

    <v-col cols="12">
      <v-checkbox v-model="keybeUi.showCustomButton"
                  color="kbBlue"
                  :label="$t('general.showCustomButton')">
      </v-checkbox>
    </v-col>

    <v-col cols="12" v-if="keybeUi.showCustomButton">
      <v-text-field v-model="keybeUi.textCustomButton"
                    color="kbDarkBlueText"
                    :label="$t('general.buttonText')"
                    counter="10"
                    maxLength="10">
      </v-text-field>
    </v-col>

    <v-col cols="12" v-if="keybeUi.showCustomButton">
      <v-text-field v-model="keybeUi.urlCustomButton"
                    color="kbDarkBlueText"
                    :label="$t('general.redirectionUrl')">
      </v-text-field>
    </v-col>

    <v-col class="py-2 pl-2" cols="12" >
        <h3 class="kbDarkBlueText--text" style="display: inline;">{{$t('general.requestData')}}</h3>
    </v-col>

    <v-col cols="12">
      <h6 class="kbDarkBlueText--text">{{$t('general.defaultData')}}</h6>
    </v-col>

    <v-col cols="12">
      <v-divider></v-divider>
    </v-col>

    <v-col cols="12" sm="6" md="4">
      <v-checkbox color="kbBlue"
                  hide-details
                  :label="$t('general.identification')"
                  v-model="keybeUi.identification"></v-checkbox>
    </v-col>

    <v-col cols="12" sm="6" md="4">
      <v-checkbox color="kbBlue"
                  hide-details
                  :label="$t('general.address')"
                  v-model="keybeUi.address"></v-checkbox>
    </v-col>

    <v-col cols="12" sm="6" md="4">
      <v-checkbox color="kbBlue"
                  hide-details
                  :label="`${$t('general.address')} 2`"
                  v-model="keybeUi.address2"></v-checkbox>
    </v-col>

    <v-col cols="12" sm="6" md="4">
      <v-checkbox color="kbBlue"
                  hide-details
                  :label="`${$t('general.state')} / ${$t('general.department')}`"
                  v-model="keybeUi.department"></v-checkbox>
    </v-col>

    <v-col cols="12" sm="6" md="4">
      <v-checkbox color="kbBlue"
                  hide-details
                  :label="$t('general.city')"
                  v-model="keybeUi.city"></v-checkbox>
    </v-col>

    <v-col cols="12" sm="6" md="4">
      <v-checkbox color="kbBlue"
                  hide-details
                  :label="$t('general.healthProvider')"
                  v-model="keybeUi.eps"></v-checkbox>
    </v-col>

    <v-col cols="12" sm="6" md="4">
      <v-checkbox color="kbBlue"
                  hide-details
                  :label="$t('general.bloodType')"
                  v-model="keybeUi.bloodType"></v-checkbox>
    </v-col>

    <!--<v-flex xs12>-->
      <!--<v-layout v-row align-center px-2>-->
        <!--<h6>Datos personalizados</h6>-->
        <!--<v-spacer></v-spacer>-->
        <!--<v-btn outlined rounded color="primary">-->
          <!--<v-icon>add</v-icon>-->
          <!--Agregar-->
        <!--</v-btn>-->
      <!--</v-layout>-->
    <!--</v-flex>-->

    <!--<v-flex xs12>-->
      <!--<v-divider></v-divider>-->
    <!--</v-flex>-->

    <!--<v-flex xs12>-->
      <!--<v-layout pa-2 row align-center justify-center>-->
        <!--<v-icon left color="red">clear</v-icon>-->
        <!--No has agregado ningún campo personalizado-->
      <!--</v-layout>-->
    <!--</v-flex>-->

    <!--<v-flex xs12>-->
      <!--<v-layout v-row wrap>-->
        <!--<v-flex xs8>-->
          <!--<v-text-field label="Etiqueta"></v-text-field>-->
        <!--</v-flex>-->

        <!--<v-flex xs4 text-xs-center>-->
          <!--<v-switch label="Solicitar en el KeybeUI"></v-switch>-->
        <!--</v-flex>-->
      <!--</v-layout>-->
    <!--</v-flex>-->

    <v-col cols="12">
      <v-btn block
             color="kbBlue"
             dark
             :loading="updatingApp"
             @click="submit">
          {{$t('general.saveChanges')}}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
// import scriptForms from '@/libs/scriptForms'
import AttachKeybeUi from '@/pages/App/KeybeUi/AttachKeybeUi.vue'
import ColorPicker from '@/components/dialogs/ColorPicker.vue'
import SelectPicture from '@/pages/App/KeybeUi/SelectPicture.vue'
import SocialNetworks from '@/pages/App/KeybeUi/SocialNetworks.vue'
export default {
  components: { AttachKeybeUi, ColorPicker, SelectPicture, SocialNetworks },
  computed: {
    ...mapState({
      selectedApp: state => state.apps.selectedApp
    }),
    profileUi () {
      return this.$store.getters.profileUi
    },
    registerModeItems () {
      return [
        { text: `${this.$t('general.email')} / ${this.$t('general.phone')}`, value: 'dual' },
        { text: this.$t('general.email'), value: 'email' },
        { text: this.$t('general.phone'), value: 'phone' }
      ]
    }
  },
  created () {
    this.actualizarVariables()
  },
  data () {
    return {
      selectPictureDialog: false,
      colorPickerDialog: false,
      focus: 'none',
      keybeUi: {
        identification: '',
        personalizedSentence: '',
        loginPhrase: '',
        registerPhrase: '',
        address: '',
        address2: '',
        department: '',
        city: '',
        eps: '',
        bloodType: '',
        hideSocialNetworks: '',
        labelLoginButton: '',
        labelRegisterButton: '',
        registerMode: '',
        showRegisterFirst: '',
        showCustomButton: false,
        textCustomButton: '',
        urlCustomButton: ''
      },
      showAttachKeybeUiDialog: false,
      updatingApp: false,
      uploadingPhoto: false
    }
  },
  methods: {
    submit () {
      this.updatingApp = true
      const extradata = [
        {
          access: 'public',
          field: 'profileUi',
          value: this.keybeUi
        }
      ]

      const companyId = this.$store.getters.companyUuid
      const appId = this.$store.getters.appUuid
      const data = { extradata: extradata }
      this.$store.dispatch('updateApp', { companyId, appId, data }).then(() => {
        this.updatingApp = false
        notifications.success(this.$t('general.applicationSuccessfullyUpdated'))
      }).catch(error => {
        this.updatingApp = false
        notifications.error(error.message)
      })
    },
    actualizarVariables () {
      this.keybeUi = {
        identification: this.profileUi.identification,
        personalizedSentence: this.profileUi.personalizedSentence,
        loginPhrase: this.profileUi.loginPhrase,
        registerPhrase: this.profileUi.registerPhrase,
        address: this.profileUi.address,
        address2: this.profileUi.address2,
        department: this.profileUi.department,
        city: this.profileUi.city,
        eps: this.profileUi.eps,
        bloodType: this.profileUi.bloodType,
        hideSocialNetworks: this.profileUi.hideSocialNetworks || false,
        labelLoginButton: this.profileUi.labelLoginButton,
        labelRegisterButton: this.profileUi.labelRegisterButton,
        registerMode: this.profileUi.registerMode || 'dual',
        showRegisterFirst: this.profileUi.showRegisterFirst,
        showCustomButton: this.profileUi.showCustomButton || false,
        textCustomButton: this.profileUi.textCustomButton,
        urlCustomButton: this.profileUi.urlCustomButton
      }
    },
    showAttachKeybeUi () {
      this.showAttachKeybeUiDialog = true
    },
    updatePicture (image) {
      this.uploadingPhoto = true

      const companyId = this.$store.getters.companyUuid
      const appId = this.$store.getters.appUuid

      const data = { photo: image.url }

      this.$store.dispatch('updateApp', { companyId, appId, data }).then(() => {
        this.uploadingPhoto = false
        notifications.success(this.$t('general.photoSuccessfullyUpdated'))
        const appId = this.$store.state.apps.selectedApp.UUID
        this.$store.dispatch('getApp', { appId, getStatistics: false })
        this.toggleModal(false)
      }).catch(error => {
        this.uploadingPhoto = false
        console.log(error)
      })
    }
  },
  watch: {
    profileUi (value) {
      this.actualizarVariables()
    }
  }
}
</script>
